import { withInstall } from '@park-ui/utils'

import Image from './src/image.vue'

export const ElImage = withInstall(Image)
export default ElImage

export * from './src/image'
